import React, { useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../utils/firebase";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshUser = async () => {
        if (!!currentUser && auth.currentUser) {
            const fighterRef = doc(db, "fighters", currentUser?.uid);
            const fighterSnap = await getDoc(fighterRef);

            if (fighterSnap.exists()) {
                const fighterData = fighterSnap.data() ?? {};
                setCurrentUser((prev) => ({
                    ...(prev ?? {}),
                    fighter: {
                        ...(prev?.fighter ?? {}),
                        ...fighterData,
                    },
                }));
            }
        }
    };

    const optimisticallyUpdateToFighter = (fighterData) => {
        if (currentUser && auth.currentUser) {
            setCurrentUser((prev) => ({
                ...prev,
                role: "fighter",
                fighter: {
                    ...fighterData,
                },
            }));
        }
    };

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            // console.log("onAuthStateChanged() user: ", user)
            let data = {};
            if (!!user) {
                data = {
                    ...data,
                    ...user,
                };
                const userRef = doc(db, "users", user.uid);
                const userSnap = await getDoc(userRef);

                const fighterRef = doc(db, "fighters", user.uid);
                const fighterSnap = await getDoc(fighterRef);

                if (userSnap.exists()) {
                    const userData = userSnap.data();
                    const fighterData = fighterSnap.data() ?? {};
                    data = {
                        ...data,
                        ...userData,
                        fighter: fighterData,
                    };
                }
                setCurrentUser(data);
            } else {
                setCurrentUser(null);
            }
            setLoading(false);
        });

        return unsubscribe;
    }, []);

    return (
        <AuthContext.Provider value={{ currentUser, refreshUser, optimisticallyUpdateToFighter }}>
            {!loading && children}
        </AuthContext.Provider>
    );
}
